export default __webpack_public_path__ + "static/skype-aec5665ded1739fa9ce60702fe757ac6.gif";